import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { CardHeader } from 'reactstrap';
import CheckBoxListItem from './CheckBoxListItem';
import { transformPvIntoPeriodo } from './Utils';

const useStyles = makeStyles({
    root: {
        minWidth: 200,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    header: {
        textAlign: 'center',
    },
});

const Periodo = ({ items, stateless }) => {
    const classes = useStyles();
    const periodos = [...new Set(['Todos', ...items.map((item) => transformPvIntoPeriodo(item.pv))])];
    periodos.sort((left, rigth) => Number(left) > Number(rigth));

    return (
        <Card className={classes.root}>
            <CardHeader className={classes.header}>Período</CardHeader>
            <CardContent>
                <CheckBoxListItem items={periodos} name={'periodo'} stateless={stateless} />
            </CardContent>
        </Card>
    );
};

export default Periodo;
